import React from 'react';
import { Route, Routes as Switch } from 'react-router';

import { ProvidersPage } from './providers/providersPage';
import { SelectionPage } from './selection/selectionPage';

const AccessToMedication = (): React.ReactElement => {
  return (
    <Switch>
      <Route path={'/:insurance'} element={<ProvidersPage />} />
      <Route path={'/'} element={<SelectionPage />} />
    </Switch>
  );
};

export { AccessToMedication };
